export default "__VITE_ASSET__Bdmp_NYr__"